
<div class="container my-5" *ngIf="lottoItem">
  <div [innerHTML]="lottoItem.TermsAndConditions"></div>
</div>
